const convertEvidenceVariableHandlingToCodeableConcept = (handling, handlingDetail) => {
    if (!handling) {
        return "";
    }
    if (typeof handling === "object") {
        return handling;
    }
    if (typeof handling === "string") {
        if (handling === "boolean") {
            return {
                "coding": [{
                    "system": "https://fevir.net/sevco",
                    "code": "STATO:0000724",
                    "display": "boolean variable"
                }]
            };
        } else if (handling === "continuous") {
            return {
                "coding": [{
                    "system": "https://fevir.net/sevco",
                    "code": "STATO:0000251",
                    "display": "continuous variable"
                }]
            };
        } else if (handling === "dichotomous") {
            return {
                "coding": [{
                    "system": "https://fevir.net/sevco",
                    "code": "STATO:0000090",
                    "display": "dichotomous variable"
                }]
            };
        } else if (handling === "polychotomous") {
            return {
                "coding": [{
                    "system": "https://fevir.net/sevco",
                    "code": "STATO:0000087",
                    "display": "polychotomous variable"
                }]
            };
        } else if (handling === "ordinal") {
            return {
                "coding": [{
                    "system": "https://fevir.net/sevco",
                    "code": "STATO:0000228",
                    "display": "ordinal variable"
                }]
            };
        } else if (handling === "extension" && handlingDetail) {
            return handlingDetail;
        }
        return { "text": handling };
    }
}
export default convertEvidenceVariableHandlingToCodeableConcept;